export default function classNames (...classes: (string | null | undefined)[]): string {
  return classes.filter(c => typeof c === "string").join(" ");
}
